import React from "react";
import "./ContentTypes.css"

const Heading = ({ heading, index }) => {
  return <h2 key={index}>{heading}</h2>;
};

export default Heading;
